import { getInitialStateFromConfig } from "helpers/form";

const config = {
    metaData: {},
    data: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
